export enum HotelRoomStatusType {
  OPEN_SALE = 'OpenSale',
  CLOSE_SALE = 'CloseSale',
  ASK_SELL = 'AskSell',
}
